import { Injectable } from '@angular/core';
import { Business } from '@models/businesses';
import {
	Matter,
	PersonMatterClient,
	BusinessMatterClient,
} from '@models/matter';
import { AllAdjustmentsCalculated } from '@state/matter/adjustments/adjustments.selectors';
import { cloneDeep } from 'lodash';
import { BaseFormMapper } from '../../base-form-mapper';
import { NameFormattingSettings } from '@models/businessSettings/settings';

@Injectable({
	providedIn: 'root',
})
export class HOME_TRUST_FINAL_REPORT_Mapper extends BaseFormMapper<HOME_TRUST_FINAL_REPORT> {
	CloserToFormMappings = Mappings;

	mergeFormData(
		formData: HOME_TRUST_FINAL_REPORT,
		matter: Matter,
		nameFormattingSettings: NameFormattingSettings,
		sellers: (PersonMatterClient | BusinessMatterClient)[],
		buyers: (PersonMatterClient | BusinessMatterClient)[],
		adjustments: AllAdjustmentsCalculated,
		business: Business,
	) {
		const _formData = formData
			? cloneDeep(formData)
			: ({} as HOME_TRUST_FINAL_REPORT);

		return _formData;
	}

	MapValues(): Partial<HOME_TRUST_FINAL_REPORT> {
		return {};
	}
}

const Mappings: HOME_TRUST_FINAL_REPORT = {
	// "0":"topmostSubform[0]",
	// "1":"topmostSubform[0].Page3[0]",
	firmAddress: 'topmostSubform[0].Page3[0].NOTAIRE_ADRESSE[0]',
	firmName: 'topmostSubform[0].Page3[0].NOTAIRE_ETUDE[0]',
	solicitorSignature: 'topmostSubform[0].Page3[0].SIGNATURE[0]',
	executedCopyOfBorrowingCost: 'topmostSubform[0].Page3[0].COB_ENCLOSED[0]',
	executedCopyOfMortgageLoanCommitment:
		'topmostSubform[0].Page3[0].COMMIT_ENCLOSED[0]',
	executedStatutoryDeclaration:
		'topmostSubform[0].Page3[0].STATUTORY_ENCLOSED[0]',
	survey: 'topmostSubform[0].Page3[0].SURVEYOR_CERT_ENCLOSED[0]',
	propertyInsurancePolicy: 'topmostSubform[0].Page3[0].FIRE_POLICY_ENCLOSED[0]',
	acknowledgmentAndDirectionReFunds:
		'topmostSubform[0].Page3[0].ACKNOW_ENCLOSED[0]',
	copyOfTitleInsurancePolicy:
		'topmostSubform[0].Page3[0].TITLE_INS_ENCLOSED[0]',
	certificateAgainstMortgagorAndGuarantor:
		'topmostSubform[0].Page3[0].EXECERTIFICATE_ENCLOSED[0]',
	registeredFinancingStatement: 'topmostSubform[0].Page3[0].RFS_ENCLOSED[0]',
	duplicateInstrumentNumber:
		'topmostSubform[0].Page3[0].REG_CHARGE_ENCLOSED[0]',
	chargeAcknowledgement: 'topmostSubform[0].Page3[0].CHARGE_ACK_ENCLOSED[0]',
	taxProvince: 'topmostSubform[0].Page3[0].CORPORATION_TAX_PROVINCE[0]',
	// "17":"topmostSubform[0].Page2[0]",
	landTitleSystemOption2:
		'topmostSubform[0].Page2[0].LAND_TITLES_NO_CERTIFICATE[0]',
	landTitleSystemOption1:
		'topmostSubform[0].Page2[0].LAND_TITLES_NO_EXECUTION[0]',
	registrySystemOption2: 'topmostSubform[0].Page2[0].REG_SYS_NO_CERTIFICATE[0]',
	registrySystemOption1: 'topmostSubform[0].Page2[0].REG_SYS_NO_EXECUTION[0]',
	fireInsuranceAgentPhone:
		'topmostSubform[0].Page2[0].FIRE_INSURANCE_POLICY_AGENT_ADDRESS[0]',
	fireinsuranceAgentName:
		'topmostSubform[0].Page2[0].FIRE_INSURANCE_POLICY_AGENT_NAME[0]',
	fireInsuranceExpireDate:
		'topmostSubform[0].Page2[0].FIRE_INSURANCE_EXPIRE_DATE[0]',
	fireInsuranceAmount: 'topmostSubform[0].Page2[0].FIRE_INSURANCE_AMOUNT[0]',
	fireInsurancePolicyNumber:
		'topmostSubform[0].Page2[0].FIRE_INSURANCE_POLICY_NUM[0]',
	fireInsuranceCompanyName:
		'topmostSubform[0].Page2[0].FIRE_INSURANCE_COMPANY[0]',
	fireInsuranceRank: 'topmostSubform[0].Page2[0].INSURANCE_RANK[0]',
	// "29":"topmostSubform[0].Page1[0]",
	taxes: 'topmostSubform[0].Page1[0].REALTY_TAXES[0]',
	publicationDate: 'topmostSubform[0].Page1[0].DATE_PUBLICATION_PRET[0]',
	registrationNumber: 'topmostSubform[0].Page1[0].NO_PUBLICATION_PRET[0]',
	// "33":"topmostSubform[0].Page1[0].REGISTRATION_DIVISION[0]",
	mortgageDate: 'topmostSubform[0].Page1[0].MORTAGE_DATE[0]',
	guarantors: 'topmostSubform[0].Page1[0].GUA_LINE_PDF[0]',
	briefLegalDescription:
		'topmostSubform[0].Page1[0].LEGAL_DESC_RFF_RF_NOPID[0]',
	securityAddress: 'topmostSubform[0].Page1[0].ADRESSE_PROPRIETE[1]',
	chargorsAddress: 'topmostSubform[0].Page1[0].COB_LINE_ADDRESS[0]',
	chargorsConsentingSpouse: 'topmostSubform[0].Page1[0].NOWNSPOUSE[0]',
	chargors: 'topmostSubform[0].Page1[0].COB_LINE_HAS_ENTERED[1]',
	titleInsuranceCarrierName:
		'topmostSubform[0].Page1[0].TITLE_INSURANCE_CARRIER_NAME[0]',
	titleInsurancePolicyNumber:
		'topmostSubform[0].Page1[0].TITLE_INSURANCE_POLICY_NUM[0]',
	titleInsuranceRank: 'topmostSubform[0].Page1[0].TITLE_INSURANCE_RANK[0]',
	dateMonth: 'topmostSubform[0].Page1[0].INS_DATED_MONTH_YEAR[0]',
	dateDay: 'topmostSubform[0].Page1[0].INS_DATED_DAY[0]',
	propertyAddress: 'topmostSubform[0].Page1[0].ADRESSE_PROPRIETE[0]',
	re: 'topmostSubform[0].Page1[0].COB_LINE_HAS_ENTERED[0]',
	from: 'topmostSubform[0].Page1[0].NOTAIRE_NOM_COMPLET[0]',
	dateOfMortgage: 'topmostSubform[0].Page1[0].DATE_OF_MORTGAGE[0]',
	// "50":"topmostSubform[0].Page1[0].BARCODE_FINAL_REPORT[0]",
	// "51":"topmostSubform[0].Page1[0].FAX_NO[0]",
	mortgageNumber: 'topmostSubform[0].Page1[0].MORTGAGE_NUMBER[0]',
};

export interface HOME_TRUST_FINAL_REPORT {
	from: string;
	re: string;
	dateOfMortgage: string;
	mortgageNumber: string;
	propertyAddress: string;
	dateDay: string;
	dateMonth: string;

	titleInsuranceRank: string;
	titleInsurancePolicyNumber: string;
	titleInsuranceCarrierName: string;
	registrationNumber: string;

	chargors: string;
	chargorsConsentingSpouse: string;
	chargorsAddress: string;
	securityAddress: string;
	briefLegalDescription: string;
	guarantors: string;

	mortgageDate: string;
	publicationDate: string;

	taxes: string;

	fireInsuranceRank: string;
	fireInsuranceCompanyName: string;
	fireInsuranceAmount: string;
	fireinsuranceAgentName: string;
	fireInsurancePolicyNumber: string;
	fireInsuranceExpireDate: string;
	fireInsuranceAgentPhone: string;

	registrySystemOption1: string;
	registrySystemOption2: string;

	landTitleSystemOption1: string;
	landTitleSystemOption2: string;

	taxProvince: string;

	chargeAcknowledgement: string;
	duplicateInstrumentNumber: string;
	registeredFinancingStatement: string;
	certificateAgainstMortgagorAndGuarantor: string;
	copyOfTitleInsurancePolicy: string;
	acknowledgmentAndDirectionReFunds: string;
	propertyInsurancePolicy: string;
	survey: string;
	executedStatutoryDeclaration: string;
	executedCopyOfMortgageLoanCommitment: string;
	executedCopyOfBorrowingCost: string;

	solicitorSignature: string;
	firmName: string;
	firmAddress: string;
}
